var _style, _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0171CC;}\r\n\t.st1{fill:#595959;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21,5.1c0-0.3,0-0.7,0-1C21,3.5,21.5,3,22.1,3c0.6,0,1.1,0.5,1.1,1.2c0,1.5,0,3,0,4.5c0,0.7-0.5,1.1-1.2,1.1 c-1.5,0-3,0-4.4,0c-0.7,0-1.2-0.5-1.2-1.1c0-0.6,0.5-1.1,1.2-1.1c0.7,0,1.4,0,2.1,0c-0.1-0.1-0.1-0.2-0.2-0.3 c-2.2-3.2-5.2-4.6-9-4.1C6.9,3.6,4.1,6.3,3.2,9.9c-0.2,0.6-0.6,1-1.2,1c-0.7-0.1-1.2-0.7-1-1.4C1.3,8.2,1.8,7,2.5,5.9 C4.4,3,7.1,1.2,10.6,0.8c4.1-0.5,7.5,0.9,10.2,4.1C20.8,5,20.9,5.1,21,5.1C21,5.2,21,5.1,21,5.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3,18.8c0,0.4,0,0.8,0,1.2c0,0.6-0.4,1-1,1.1c-0.5,0.1-1-0.3-1.2-0.8c0-0.1,0-0.3,0-0.4c0-1.4,0-2.9,0-4.3 c0-0.8,0.4-1.2,1.2-1.2c1.5,0,3,0,4.4,0c0.6,0,1,0.4,1.1,1c0.1,0.5-0.3,1-0.8,1.2c-0.1,0-0.3,0-0.4,0c-0.6,0-1.2,0-1.8,0 c-0.1,0-0.1,0-0.2,0c0.1,0.1,0.1,0.2,0.2,0.3c2.2,3.2,5.2,4.6,9,4.1c3.7-0.5,6.5-3.2,7.4-6.8c0.2-0.7,0.7-1.1,1.2-1 c0.7,0.1,1.1,0.7,1,1.5c-0.3,1-0.6,2.1-1.2,3c-1.9,3.2-4.7,5.2-8.4,5.6c-4.2,0.5-7.6-1-10.2-4.2C3.1,18.9,3.1,18.9,3,18.8z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -15.7,
    y: 21,
    className: "st1",
    width: 9,
    height: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/Reload.1a54c28b9ff992fb45a23900493bc065.svg";
export { ForwardRef as ReactComponent };